import ViralApi from '../Viral/ViralApi';

export default class ReferralApi {
  static create(contact_details, referralUtms) {
    const data = {
      viral_loop_uuid: REFER_A_FRIEND_VIRAL_LOOP,
      contact_details: contact_details,
      invitation_utms: referralUtms,
    };
    return ViralApi.post('invitations', data);
  }

  static recommended_contacts(externalUserDetails) {
    const data = { viral_loop_uuid: REFER_A_FRIEND_VIRAL_LOOP, external_user_details: externalUserDetails };
    return ViralApi.post('contacts/recommended', data);
  }
}
